/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Rename_LabelInputs */



/**
* | output |
* | --- |
* | "New name" |
*
* @param {Explorer_Info_Rename_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_rename_label = /** @type {((inputs?: Explorer_Info_Rename_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Rename_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouveau nom")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Name")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo nome")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новое название")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo nombre")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しい名前")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नया नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo nome")
	return /** @type {LocalizedString} */ ("New name")
});